import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

// Import feature slices
import { authReducer, profileReducer } from "./slices";
// Import all API services
import {
  //
  authApi,
  dashboardApi,
  partnersApi,
  transactionsApi,
  paymentsApi,
  productsApi,
  campaignsApi,
  commissionsApi,
  contentsApi,
  adminsApi,
  profileApi,
  filterOptionsApi,
} from "../services";

// List of all API services
const apiServices = [
  //
  authApi,
  dashboardApi,
  partnersApi,
  transactionsApi,
  paymentsApi,
  productsApi,
  campaignsApi,
  commissionsApi,
  contentsApi,
  adminsApi,
  profileApi,
  filterOptionsApi,
];

// Create the store
export const store = configureStore({
  reducer: {
    // Feature slices
    auth: authReducer,
    profile: profileReducer,

    // RTK Query APIs reducers
    ...apiServices.reduce(
      (reducers, service) => ({
        ...reducers,
        [service.reducerPath]: service.reducer,
      }),
      {}
    ),
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: { warnAfter: 128 },
      thunk: true,
    }).concat(
      // RTK Query middleware
      ...apiServices.map((service) => service.middleware)
    ),
  devTools: process.env.NODE_ENV !== "production",
});

// Enable refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;
